export interface IFormOption {
  key: string;
  label: string;
  value: number | undefined | string;
}

export enum EnumType {
  "Numeric",
  "String",
}

/**
 * convertEnumToOptions makes all your dreams come true.
 * @param enumObject This is an enum where the keys are strings and the values are numbers.
 * @returns FormOption<T>[] A glorious vector returned to be used EnumMultiSelectV2 or EnumSelectV2 components for FieldSchemaFormBuilderV2
 */
export function convertEnumToOptions<T extends object>(
  enumObject: T,
  enumType?: EnumType | undefined
): IFormOption[] {
  const optionsReturnList: IFormOption[] = [];
  const allOptionsList = Object.values(enumObject);

  if (enumType && enumType === EnumType.String) {
    for (let i = 0; i < allOptionsList.length; i++) {
      optionsReturnList.push({
        key: allOptionsList[i] as string,
        label: allOptionsList[i] as string,
        value: allOptionsList[i] as string,
      });
    }

    return optionsReturnList;
  }

  // Numeric enum and default
  for (let i = 0; i < allOptionsList.length / 2; i++) {
    optionsReturnList.push({
      key: allOptionsList[i] as string,
      label: allOptionsList[i] as string,
      value: allOptionsList[allOptionsList.length / 2 + i] as number,
    });
  }

  return optionsReturnList;
}
